module.exports = __webpack_public_path__ + "img/hanuka2026.95013f56.png";